const COLORS = [
  "bg-blue-100 text-blue-600",
  "bg-purple-100 text-purple-600",
  "bg-emerald-100 text-emerald-600",
  "bg-amber-100 text-amber-600",
  "bg-rose-100 text-rose-600",
]

type Props = {
  name?: string | null
  src?: string | null
  /** Diameter in px. */
  size?: number
}

/** User avatar: photo if present, colored initials if there's a name, otherwise a default silhouette. */
export const Avatar = ({ name, src, size = 32 }: Props) => {
  const trimmed = name?.trim() || ""
  const dim = { width: size, height: size }

  if (src) {
    return (
      <img
        src={src}
        alt={trimmed}
        style={dim}
        className="rounded-full object-cover flex-shrink-0 ring-1 ring-gray-100"
      />
    )
  }

  if (!trimmed) {
    return (
      <div
        style={dim}
        className="rounded-full bg-gradient-to-br from-slate-300 to-slate-400 flex items-center justify-center flex-shrink-0 overflow-hidden ring-1 ring-gray-100"
      >
        <svg viewBox="0 0 24 24" style={{ width: size * 0.65, height: size * 0.65 }} className="text-white" fill="currentColor">
          <circle cx="12" cy="8.5" r="3.5" />
          <path d="M4 20.2c0-4.4 3.6-7.4 8-7.4s8 3 8 7.4" />
        </svg>
      </div>
    )
  }

  const initials = trimmed.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
  const color = COLORS[trimmed.charCodeAt(0) % COLORS.length]
  const fontSize = size <= 36 ? 11 : size <= 52 ? 14 : 18

  return (
    <div
      style={{ ...dim, fontSize }}
      className={`rounded-full ${color} flex items-center justify-center font-semibold flex-shrink-0`}
    >
      {initials}
    </div>
  )
}
